/* eslint-disable */
import * as utilOmniRoom from "@/api/omniroom";

const state = {
    isFilterAdvanceClear: false,
    isFilterAdvanceActive: false,
    filterRoomAdvance: {
        tags_filter: false,
        untag: false,
        tags_id: [],
    },
    numUnreadMessage: 0,
    isShowFilter: false,
    isShowBroadcast: false,
    isShowDirectChats: false,
    roomListArr: [],
    hotChatListArr: [],
    activeRoomId: "",
    activeProvider: "",
    messageListArr: [],
    textMessageArr: {
        agent_first_name: "",
        agent_id: "",
        from_me: 1,
        id: "",
        message: "",
        message_id: "",
        message_name: "",
        message_number: "",
        provider: "whatsapp",
        room_id: "",
        timeISODate: "",
        timeISODatetime: "",
        timeMinuteHour: "",
        timestamp: Date.now()
    },
    groupMessageMedia: [
        {
            thumb: "",
            src: "",
            caption: "" // Optional
        }
    ],
    groupMessageMediaFile: [
        {
            thumb: "",
            src: "",
            caption: "" // Optional
        }
    ]

};


const mutations = {
    SET_isFilterAdvanceClear: (state, value) => {
        state.isFilterAdvanceClear = value
    },
    SET_isFilterAdvanceActive: (state, value) => {
        state.isFilterAdvanceActive = value
    },
    SET_filterRoomAdvance: (state, value) => {
        state.filterRoomAdvance = value
    },
    SET_isShowFilter: (state, value) => {
        state.isShowFilter = value
    },
    SET_numUnreadMessage: (state, value) => {
        state.numUnreadMessage = value
    },
    SET_isShowBroadcast: (state, value) => {
        state.isShowBroadcast = value
    },
    SET_isShowDirectChats: (state, value) => {
        state.isShowDirectChats = value
    },
    SET_groupMessageMediaFile: (state, value) => {
        state.groupMessageMediaFile = value
    },
    SET_groupMessageMedia: (state, value) => {
        state.groupMessageMedia = value
    },
    SET_roomListArr: (state, value) => {
        state.roomListArr = value
    },
    SET_hotChatListArr: (state, value) => {
        state.hotChatListArr = value
    },
    SET_messageListArr: (state, value) => {
        state.messageListArr = value
    },
    SET_activeRoomId: (state, value) => {
        state.activeRoomId = value
    },
    SET_activeProvider: (state, value) => {
        state.activeProvider = value
    },
};

const actions = {
    setIsFilterAdvanceClear({ commit }, data) {
        commit("SET_isFilterAdvanceClear", data);
        if (data == true) {
            let paramDefault = {
                tags_filter: false,
                untag: false,
                tags_id: []
            }
            commit("SET_filterRoomAdvance", paramDefault);
        }
    },
    setIsFilterAdvanceActive({ commit }, data) {
        commit("SET_isFilterAdvanceActive", data);
    },
    setFilterRoomAdvance({ commit }, data) {
        commit("SET_filterRoomAdvance", data);
    },
    setIsShowFilter({ commit }, data) {
        commit("SET_isShowFilter", data);
    },
    resolveAll() {
        return new Promise((resolve, reject) => {
            utilOmniRoom.resolveAll().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    readAll() {
        return new Promise((resolve, reject) => {
            utilOmniRoom.readAll().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

    numUnread({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            utilOmniRoom.numUnread(dataParams).then(response => {
                const { data } = response;
                commit("SET_numUnreadMessage", data.totalRecords);

                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setIsShowBroadcast({ commit }, data) {
        commit("SET_isShowBroadcast", data);
    },
    setIsShowDirectChats({ commit }, data) {
        commit("SET_isShowDirectChats", data);
    },
    setGroupMessageMediaFile({ commit }, data) {
        commit("SET_groupMessageMediaFile", data);
    },
    setGroupMessageMedia({ commit }, data) {
        commit("SET_groupMessageMedia", data);
    },
    setRoomListArr({ commit }, data) {
        commit("SET_roomListArr", data);
    },
    textMessageHandler({ commit }, data) {
        console.log("dataTextMessageHandler", data)
    },
    setHotChatListArr({ commit }, data) {
        commit("SET_hotChatListArr", data);
    },
    setActiveRoomId({ commit }, roomId) {
        commit("SET_activeRoomId", roomId);
    },
    setActiveProvider({ commit }, provider) {
        commit("SET_activeProvider", provider);
    },
    licenseByAgent({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            utilOmniRoom.licenseByAgent(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getRoomList({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            utilOmniRoom.getRoomList(dataParams).then(response => {
                const { data } = response;
                // let dataRoom = data.data
                // commit("SET_roomListArr", dataRoom);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getHotChatList({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            utilOmniRoom.getHotChatList(dataParams).then(response => {
                const { data } = response;
                commit("SET_hotChatListArr", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getColdChatList({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            utilOmniRoom.getColdChatList(dataParams).then(response => {
                const { data } = response;
                // commit("SET_hotChatListArr", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    setResolve({ commit }, roomId) {
        return new Promise((resolve, reject) => {
            utilOmniRoom.setResolve(roomId).then(response => {
                const { data } = response;
                // commit("SET_hotChatListArr", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    isNotResolve({ commit }, roomId) {
        return new Promise((resolve, reject) => {
            utilOmniRoom.isNotResolve(roomId).then(response => {
                const { data } = response;
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/omniroom.js